import useSWR from 'swr';

import apiRequest from '@/services/apiRequest';
import { getCoreApi } from '@/utility/getCoreApi';

import { useRentalsLocationMeta } from './useRentalsLocationMeta';

type IIncome = {
  experiment: {
    new: number;
    new_vehicles: number;
    old: number;
    old_vehicles: number;
  };
  high: {
    day: number;
    month: number;
    week: number;
  };
  low: {
    day: number;
    month: number;
    week: number;
  };
};

export const useIncome = (vehicleType: string | undefined) => {
  const { data: rentalsLocationMeta } = useRentalsLocationMeta();
  const lat = rentalsLocationMeta?.lat;
  const lng = rentalsLocationMeta?.lat;

  const swrResponse = useSWR<IIncome>(
    () => {
      if (!vehicleType || lat === undefined || lng === undefined) {
        return null;
      }
      return [`${getCoreApi()}/pricing/v2`, vehicleType, lat, lng];
    },
    ([url, vehicleType, lat, lng]: [
      string,
      string | undefined,
      number | undefined,
      number | undefined,
    ]) =>
      apiRequest<IIncome>({
        url,
        params: {
          type: vehicleType,
          lat,
          lng,
        },
      }),
  );

  return swrResponse;
};
